module.exports = __webpack_public_path__ + "media/images/icons/need-help-a0f26faf92c21dcfad17ad6ea8b80351.png";